import { TaskType } from "@/api.types.v2";

export type TaskLane = "pickup" | "delivery" | "dropoff" | "return";

export const LANE_ORDER: TaskLane[] = [
  "pickup",
  "delivery",
  "dropoff",
  "return",
];

export const LANE_META: Record<
  TaskLane,
  { color: string; label: string; short: string }
> = {
  pickup: { color: "#2563EB", label: "Pickups", short: "PU" },
  delivery: { color: "#9333EA", label: "Deliveries", short: "DEL" },
  dropoff: { color: "#16A34A", label: "Drop-offs", short: "DO" },
  return: { color: "#EA580C", label: "Returns", short: "RET" },
};

export function taskLane(type: TaskType): TaskLane {
  switch (type) {
    case TaskType.CUSTOMER_PICKUP:
    case TaskType.CARRIER_PICKUP:
      return "pickup";
    case TaskType.CUSTOMER_DELIVERY:
      return "delivery";
    case TaskType.CUSTOMER_RETURN:
      return "return";
    default:
      return "dropoff";
  }
}

export type LaneCounts = Record<TaskLane, number>;

export function emptyLaneCounts(): LaneCounts {
  return { pickup: 0, delivery: 0, dropoff: 0, return: 0 };
}

export const LANE_DIR: Record<TaskLane, "up" | "down" | "return"> = {
  pickup: "up",
  delivery: "down",
  dropoff: "down",
  return: "return",
};
